import { useState } from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { useEstimateEditorStore, useEstimateStructure, XlsImporter, XlsImporterSettingsProvider } from "@tools";
import { ActionButton, Alert } from "@components";
import { ExportIcon } from "@assets";
import { useEditorWebsocket } from "@hooks";
import { CircularProgress } from "@material-ui/core";
import { MAX_VERSIONS } from "@utils";

export const Imports = observer(() => {
  const { t } = useTranslation();
  const editorStore = useEstimateEditorStore();
  const socket = useEditorWebsocket();
  const structure = useEstimateStructure();
  
  const [ showDialog, setShowDialog ] = useState(false);
  const [ showAlert, setShowAlert ] = useState(false);
  
  const { workTypes, estimateVersions } = editorStore;
  const { timeModifier, useMinMax } = structure.settings;
  
  const handleClick = () => {
    if(estimateVersions?.length < MAX_VERSIONS)
      setShowDialog(true);
    else
      setShowAlert(true);
  }
  
  const handleXlsImport = (fileName, importedStructure, importedWorkTypes) => {
    socket?.requestNewImportedVersion(importedStructure, importedWorkTypes)
    setShowDialog(false);
  }
  
  const handleXlsImportCancel = () => {
    setShowDialog(false);
  }
  
  return (
    <>
      <ActionButton
        square
        icon={ socket?.isXlsImportOngoing
          ? <CircularProgress color="primary" size={20} />
          : <ExportIcon className="-rotate-90" />
        }
        color="secondary"
        onClick={handleClick}
        name={t("views.editor.import")}
        tooltip
      />
      <Alert
        isOpen={showAlert}
        title={t("alerts.editor.version_limit.title")}
        acceptText={t("common.close")}
        onAccept={() => setShowAlert(false)}
      >
        { t("alerts.editor.version_limit.text", { limit: MAX_VERSIONS }) }
      </Alert>
      {
        showDialog &&
        <XlsImporterSettingsProvider
          workTypes={workTypes}
          addCustomWorkType={editorStore.addWorkType}
          defaultStructure={structure}
          defaultTimeModifier={timeModifier}
          defaultUseMinMax={useMinMax}
          defaultApplyReverseBuffers={structure.usedBuffers > 0}
        >
          <XlsImporter
            modalOpened={showDialog}
            onImportCancel={handleXlsImportCancel}
            onImportFinish={handleXlsImport}
          />
        </XlsImporterSettingsProvider>
      }
    </>
  );
})